module.exports = __webpack_public_path__ + "static/media/gzonetech.2b790e91.png";